export function buildFarmSettingsUrl(
  organizationId: string | undefined,
  propertyId: string | undefined
): string {
  return `${
    import.meta.env.VITE_APP_BASE_URL
  }/app/landing-organization/${organizationId}/property/${propertyId}/table-view`;
}

interface EditFieldDeepActionParams {
  organizationId: string;
  propertyId: string;
  fieldId: string;
  callbackUri: string;
}

export function buildEditFieldDeepActionUrl({
  organizationId,
  propertyId,
  fieldId,
  callbackUri,
}: EditFieldDeepActionParams): string {
  const params = new URLSearchParams({
    org_id: organizationId,
    property_id: propertyId,
    field_id: fieldId,
    callback_uri: callbackUri,
  });

  return `${import.meta.env.VITE_APP_BASE_URL}/app/deep-actions/edit-field?${params.toString()}`;
}
